import { useAuthStore } from '../components/Login/useAuthStore';
import { useLPQuery } from '../lib/hooks/useLPQuery';

export function useMeQuery() {
  const isLoggedIn = useAuthStore((state) => state.loginStatus === 'loggedIn' && !!state.accessToken);
  return useLPQuery<Me>(['me'], '/me', { enabled: isLoggedIn });
}
type Me = {
  learnerId: string;
  name?: string | null;
  portalRole: string;
  authOption?: string | null;
  languageCode?: string | null;
  country?: string | null;
  department?: string | null;
};
